

















import { computed, defineComponent, ref } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { alarm, sensor, app } from "@/store";
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    components: {
        DigitalIOListItem: () =>
            import("./Sensors/DigitalIOListItem.vue"),
        GasValveListItem: () =>
            import("./Sensors/GasValveListItem.vue"
            )
    },

    setup() {
        const { getUserSettings } = useUserSettings();

        const userSettings = ref<UserSettingsViewModel>();

        const digitalIOModel = computed<AttachedDeviceModel>(() => {
            return getItem(16);
        });
        const gasValveModel = computed<AttachedDeviceModel>(() => {
            return getItem(15);
        });
        const gasEnabled = computed<boolean>(() => {
            return alarm.armed;
        });

        const getItem = (type: number): AttachedDeviceModel => {
            let model: AttachedDeviceModel = new AttachedDeviceModel();
            if (sensor.devices && sensor.devices.length > 0) {
                let model = sensor.devices.find((value: AttachedDeviceModel) => {
                    return value.attachedDeviceTypeId === type;
                });
                if (model) {
                    return model;
                }
            }
            model.attachedDeviceTypeId = type;
            return model;
        };

        const digitalOutputNickname = computed<string>(() => {
            return userSettings.value ? userSettings.value.digitalOutputNickname : "Digital Output";
        });

        // Listens for the event emitted
        const handleOnNewNickname = (model: UserSettingsViewModel) => {
            userSettings.value.digitalOutputNickname = model.digitalOutputNickname;
        };

        const panel = computed<number>(() => {
            if (app.getControlPanelOpen) {
                console.log("app.getControlPanelIndex", app.getControlPanelIndex);
                return app.getControlPanelIndex;
            } else {
                console.log("app.getControlPanelIndex", -1);
                return -1;
            }
        });

        getUserSettings().then((value: UserSettingsViewModel) => {
            userSettings.value = value;
        });

        return {
            gasEnabled,
            gasValveModel,
            digitalIOModel,
            digitalOutputNickname,
            handleOnNewNickname,
            panel
        };
    }
});
